export function isLinkGroup(link) {
    return typeof link === 'string';
}
export { isLinkGroup as isGroup };
export default isLinkGroup;
//# sourceMappingURL=isGroup.js.map